import art1 from "./Articles/art1"
import art2 from "./Articles/art2"
import art3 from "./Articles/art3"
import art4 from "./Articles/art4"
import art5 from "./Articles/art5"
import art6 from "./Articles/art6"
import art7 from "./Articles/art7"
import art8 from "./Articles/art8"

const articles = [
    {
        id:1,
        // blog_creative:"/images/creatives/home-vid-card-1.jpg",
        blog_creative:"/images/creatives/home-vid-card-1.png",
        main_heading:"What Does Prevention Actually Look Like After 40?",
        paragraph:" After 40, your body changes in ways you can’t always feel, hormones shift, metabolism slows, and inflammation quietly builds. True prevention goes beyond an annual check-up. It’s advanced diagnostics, personalized risk profiling, and a long-term strategy tailored to you. At The Toronto Clinic, we map your future health before problems appear.",
        slug_url:"what-does-prevention-actually-look-like-after-40",
        date:"",
        contentFile:art1
    },
    {
        id:2,
        // blog_creative:"/images/creatives/home-vid-card-2.jpg",
        blog_creative:"/images/creatives/home-vid-card-2.png",
        main_heading:"How Stress & Burnout Affect Long-Term Health",
        paragraph:"Chronic stress quietly reshapes your body, increasing disease risk over time.",
        slug_url:"how-stress-and-burnout-affect-long-term-health",
        date:"",
        contentFile:art2
    },
    {
        id:3,
        // blog_creative:"/images/creatives/home-vid-card-3.jpg",
        blog_creative:"/images/creatives/home-vid-card-3.png",
        main_heading:"Your Metabolism Isn’t Broken — It’s Misunderstood",
        paragraph:"After 40, metabolism changes are natural and can be trained for better health.",
        slug_url:"your-metabolism-isnt-broken-its-misunderstood",
        date:"",
        contentFile:art3
    },
    {
        id:4,
        // blog_creative:"/images/creatives/home-vid-card-1.jpg",
        blog_creative:"/images/creatives/home-vid-card-4.png",
        main_heading:"The Executive Health Exam: Why One Day Can Change Your Year",
        paragraph:"One day can reveal your health risks and give you a clear action plan.",
        slug_url:"the-executive-health-exam-why-one-day-can-change-your-year",
        date:"",
        contentFile:art4
    },
    {
        id:5,
        // blog_creative:"/images/creatives/home-vid-card-2.jpg",
        blog_creative:"/images/creatives/home-vid-card-5.png",
        main_heading:"Women’s Health After 40: What Should Change?",
        paragraph:"",
        slug_url:"womens-health-after-40-what-should-change",
        date:"",
        contentFile:art5
    },
    {
        id:6,
        // blog_creative:"/images/creatives/home-vid-card-3.jpg",
        blog_creative:"/images/creatives/home-vid-card-6.png",
        main_heading:"Advanced Blood Work: What Standard Labs Often Miss",
        paragraph:"",
        slug_url:"advanced-blood-work-what-standard-labs-often-miss",
        date:"",
        contentFile:art6
    },
    {
        id:7,
        // blog_creative:"/images/creatives/home-vid-card-1.jpg",
        blog_creative:"/images/creatives/home-vid-card-7.png",
        main_heading:"Sleep, Recovery & Performance in High Performers",
        paragraph:"",
        slug_url:"sleep-recovery-and-performance-in-high-performers",
        date:"",
        contentFile:art7
    },
    {
        id:8,
        blog_creative:"/images/creatives/home-vid-card-8-new.jpeg",
        main_heading:"HALO inventors honoured at UHN awards",
        paragraph:"",
        slug_url:"halo-inventors-honoured-at-uhn-awards",
        date:"",
        fullWidth:true,
        contentFile:art8
    },
]


export default articles